var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"block":_vm.block,"to":_vm.to,"variant":"outline-primary"}},[_c('feather-icon',{attrs:{"icon":"ChevronLeftIcon"}}),_vm._v(" Kembali ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }